import { FC, useState } from "react";
import {ModalBody} from "@/widgets/ModalParts";
import { FaCheck, FaFacebook } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { MdContentCopy } from "react-icons/md";
import {Button} from "@/components/buttons/Button";
import {Modal} from "@/widgets/Modal";
import { FacebookShareButton } from "react-share";
import { useCopyToClipboard } from "@/hooks/useCopyToClipboard";

interface props {
    quote: string;
    link: string;
    hashtag: string;
    isVisible: boolean;
    onClose: () => void;
}
export const FacebookShareModal: FC<props> = ({ hashtag, isVisible, link, onClose, quote }) => {
    const [isTextCopied, setIsTextCopied] = useState(false);
    const { copyToClipboard} = useCopyToClipboard();
    const handleCopyQuote = () => {
        if (isTextCopied) return;
        setIsTextCopied(true);
        copyToClipboard(quote);
        setTimeout(() => {
            setIsTextCopied(false);
        }, 10000);
    };
    return (
        <Modal size="xs1" isOpen={isVisible} toggle={onClose} contentClassName="facebook-share-modal">
            <IoMdClose className="facebook-share-modal_close" onClick={onClose} />
            <ModalBody className="facebook-share-modal_body">
                <div className="facebook-share-modal_body_heading">
                    <FaFacebook />
                    <div className="facebook-share-modal_body_heading_text">
                        <h5>Share to facebook</h5>
                        <span>Copy this message and paste it when you share</span>
                    </div>
                </div>
                <div className="facebook-share-modal_body_content">
                    <div className="facebook-share-modal_body_content_field">
                        <textarea value={quote} readOnly></textarea>
                        <Button variant={isTextCopied ? "ghost" : "primary"}
                            onClick={handleCopyQuote}
                            rightIcon={isTextCopied ? FaCheck : MdContentCopy}

                        >
                            {isTextCopied ? "Copied" : "Copy"}
                        </Button>
                    </div>

                    <FacebookShareButton
                        quote={quote}
                        url={link}
                        hashtag={hashtag}
                        style={{
                            backgroundColor: "transparent",
                        }}
                    >
                        <div className="facebook-share-modal_body_content_button">
                            <FaFacebook /> <span>Share to Facebook</span>
                        </div>
                    </FacebookShareButton>
                </div>
            </ModalBody>
        </Modal>
    );
};
